import { Primitives as o } from "./constants.js";
import { hasValue as e } from "./fp/optional/utils.js";
const s = (t) => o.some((r) => typeof t === r), c = (t) => {
  if (typeof t != "object" || t === null || Array.isArray(t))
    return !1;
  const r = Object.getPrototypeOf(t);
  return r === null || r === Object.prototype;
}, m = (t) => !Object.values(t).some(e), p = (t) => {
  const r = Number(t);
  return Number.isFinite(r) ? r : null;
}, b = (t, r) => t instanceof Error ? t : new Error(r ?? String(t));
export {
  m as isEmptyObject,
  c as isPlainObject,
  s as isPrimitive,
  b as toError,
  p as toFiniteNumber
};
//# sourceMappingURL=utils.js.map
